import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { EkButtonComponent } from '@beta-foundations/ui-kit/buttons';
import {
    EkDialogBodyComponent,
    EkDialogFooterComponent,
    EkDialogHeaderComponent
} from '@beta-foundations/ui-kit/overlay/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EkDividerComponent } from '@beta-foundations/ui-kit/panel/divider';
import { combineLatest, map, Observable } from 'rxjs';
import { InsegnamentoItem, InsegnamentoService } from '../../services/insegnamento.service';
import { CambioInsegnamentoComponent } from '../cambio-insegnamento-modal/cambio-insegnamento-modal.component';
import { SettingsService } from '../../services/settings.service';
import { UserService } from '../../services/user.service';
import { User, UserGroup } from '../../models/user';

@Component({
  selector: 'app-insegnamento-legenda-modal',
  standalone: true,
  imports: [CommonModule,
    EkDialogHeaderComponent,
    EkDialogBodyComponent,
    EkDialogFooterComponent,
    TranslateModule,
    EkButtonComponent,
    EkDividerComponent],
  templateUrl: './insegnamento-legenda-modal.component.html',
  styleUrl: './insegnamento-legenda-modal.component.scss'
})
export class InsegnamentoLegendaModalComponent implements OnInit{
  selectedItem$: Observable<InsegnamentoItem | null>;
  public canOpenChangeModal$: Observable<boolean>;
  constructor(
    private dialogService: DialogService,
    public ref: DynamicDialogRef,
    private insegnamentoService: InsegnamentoService,
    private settingsService: SettingsService,
    private userService: UserService
  ) {
    this.selectedItem$ = this.insegnamentoService.selectedTeaching$;

    const canManageSubtenants$ = combineLatest([
      this.settingsService.isFeatureEnabled('subtenant', 'PERMISSIONS'),
      this.userService.getUser()
    ]).pipe(
      map(([enabled, user]) => enabled && this.isSubtenantManager(user))
    );

    this.canOpenChangeModal$ = combineLatest([
      this.insegnamentoService.teachings$,
      canManageSubtenants$
    ]).pipe(
      map(([teachings, canManage]) => {
        const count = teachings?.length ?? 0;
        return count > 1 || (count >= 1 && canManage);
      })
    );
  }

  private isSubtenantManager(user: User | null): boolean {
    return user?.group === UserGroup.SYS_ADMIN || user?.group === UserGroup.ADMIN;
  }

  close() {
    this.ref.close();
  }

  ngOnInit(): void {
    this.selectedItem$ = this.insegnamentoService.selectedTeaching$;
  }

  openChangeModal() {
      this.ref.close();
      this.ref = this.dialogService.open(CambioInsegnamentoComponent, {
          width: "1200px",
          contentStyle: {overflow: "auto"},
          baseZIndex: 10000,
          maximizable: false,
      });
  }
}
